import { FC, useCallback } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { PlannedAmountItem } from "./PlannedAmountItem";
import { getPlannedBudgetDateLabel } from "../../../../../../../../../utils/helpers/getPlannedBudgetDateLabel";
import { BudgetPeriod } from "@/services/cloudchipr.api";
import { useAppSelector } from "@/store/hooks";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";

interface BudgetPlannedAmountsProps {
  errors?: string[];
  plannedAmounts: number[];
  onPlannedAmountChange(value: (number | undefined)[] | null): void;
  period: BudgetPeriod;
  startDate: string;
}

export const BudgetPlannedAmounts: FC<BudgetPlannedAmountsProps> = ({
  errors,
  plannedAmounts,
  onPlannedAmountChange,
  period,
  startDate,
}) => {
  const quarterStartMonth = useAppSelector(
    organisationQuarterStartMonthSelector,
  );

  const plannedAmountsChangeHandler = useCallback(
    (plannedAmount: number | undefined, index: number) => {
      onPlannedAmountChange(
        plannedAmounts.map((pa, i) => (i === index ? plannedAmount : pa)),
      );
    },
    [onPlannedAmountChange, plannedAmounts],
  );

  return (
    <Box>
      <Typography variant="body2" mb={2}>
        Budget Amounts*
      </Typography>
      <Grid container rowSpacing={1.5} columnSpacing={1}>
        {plannedAmounts.map((plannedAmount, index) => {
          const fieldError = errors?.[index];
          const label = getPlannedBudgetDateLabel(
            period,
            startDate,
            index,
            quarterStartMonth,
          );

          return (
            <Grid item xs={period === "quarterly" ? 3 : 4} key={label}>
              <PlannedAmountItem
                index={index}
                label={label}
                plannedAmount={plannedAmount ?? ""}
                fieldError={fieldError}
                onPlannedAmountChange={plannedAmountsChangeHandler}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
